import { ExternalLinkIcon } from 'lucide-react'
import {
  buildEurLexHtmlUrlFromCelex,
  parseSearchRadarCelexScopesOutput,
  resolveEurLexCelexForLinks,
  truncatePlainTextForUi,
} from './llmChatToolOutput'

export type LlmChatToolCelexScopeSourcesProps = {
  output: unknown
  emptyLabel: string
  viewOnEurLexLabel: string
}

export function LlmChatToolCelexScopeSources({
  output,
  emptyLabel,
  viewOnEurLexLabel,
}: LlmChatToolCelexScopeSourcesProps) {
  const parsed = parseSearchRadarCelexScopesOutput(output)
  if (!parsed) {
    return null
  }

  if (parsed.items.length === 0) {
    return (
      <p className='border-t border-border/40 px-3 py-2 text-[12px] text-muted-foreground'>
        {emptyLabel}
      </p>
    )
  }

  return (
    <div className='border-t border-border/40 px-3 py-2'>
      <div className='space-y-2'>
        {parsed.items.map((item, itemIndex) => {
          const eurLexUrl = buildEurLexHtmlUrlFromCelex(
            resolveEurLexCelexForLinks(item)
          )
          const regulationLabel =
            item.instrumentTitle !== null
              ? item.instrumentTitle
              : `CELEX ${item.celex}`
          return (
            <article
              key={`${item.celex}-${itemIndex}`}
              className='rounded-md border border-border bg-background p-2'
            >
              <header className='mb-1.5 flex flex-wrap items-start justify-between gap-x-2 gap-y-1'>
                <div className='min-w-0 flex-1'>
                  <div className='line-clamp-2 text-[12px] leading-snug font-semibold text-foreground'>
                    {regulationLabel}
                  </div>
                  {item.instrumentTitle !== null ? (
                    <div className='mt-0.5 text-[11px] font-normal text-muted-foreground'>
                      CELEX {item.celex}
                    </div>
                  ) : null}
                </div>
                {eurLexUrl ? (
                  <a
                    href={eurLexUrl}
                    target='_blank'
                    rel='noreferrer noopener'
                    className='inline-flex shrink-0 items-center gap-1 text-xs underline-offset-2 hover:underline'
                  >
                    {viewOnEurLexLabel}
                    <ExternalLinkIcon className='size-3' />
                  </a>
                ) : null}
              </header>
              <p className='line-clamp-3 text-xs leading-relaxed text-muted-foreground'>
                {truncatePlainTextForUi(item.evidencePreview ?? '—', 200)}
              </p>
            </article>
          )
        })}
      </div>
    </div>
  )
}
